function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module media-embed/mediaembedediting
 */
import { Plugin } from 'ckeditor5/src/core';
import { modelToViewUrlAttributeConverter } from './converters';
import MediaEmbedCommand from './mediaembedcommand';
import MediaRegistry from './mediaregistry';
import { toMediaWidget, createMediaFigureElement } from './utils';
import '../theme/mediaembedediting.css';
/**
 * The media embed editing feature.
 *
 * @extends module:core/plugin~Plugin
 */

var MediaEmbedEditing = /*#__PURE__*/function (_Plugin) {
  _inherits(MediaEmbedEditing, _Plugin);

  var _super = _createSuper(MediaEmbedEditing);

  /**
   * @inheritDoc
   */
  function MediaEmbedEditing(editor) {
    var _this;

    _classCallCheck(this, MediaEmbedEditing);

    _this = _super.call(this, editor);
    editor.config.define('mediaEmbed', {
      elementName: 'oembed',
      providers: [{
        name: 'dailymotion',
        url: /^dailymotion\.com\/video\/(\w+)/,
        html: function html(match) {
          var id = match[1];
          return '<div style="position: relative; padding-bottom: 100%; height: 0; ">' + "<iframe src=\"https://www.dailymotion.com/embed/video/".concat(id, "\" ") + 'style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;" ' + 'frameborder="0" width="480" height="270" allowfullscreen allow="autoplay">' + '</iframe>' + '</div>';
        }
      }, {
        name: 'spotify',
        url: [/^open\.spotify\.com\/(artist\/\w+)/, /^open\.spotify\.com\/(album\/\w+)/, /^open\.spotify\.com\/(track\/\w+)/],
        html: function html(match) {
          var id = match[1];
          return '<div style="position: relative; padding-bottom: 100%; height: 0; padding-bottom: 126%;">' + "<iframe src=\"https://open.spotify.com/embed/".concat(id, "\" ") + 'style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;" ' + 'frameborder="0" allowtransparency="true" allow="encrypted-media">' + '</iframe>' + '</div>';
        }
      }, {
        name: 'youtube',
        url: [/^(?:m\.)?youtube\.com\/watch\?v=([\w-]+)/, /^(?:m\.)?youtube\.com\/v\/([\w-]+)/, /^youtube\.com\/embed\/([\w-]+)/, /^youtu\.be\/([\w-]+)/],
        html: function html(match) {
          var id = match[1];
          return '<div style="position: relative; padding-bottom: 100%; height: 0; padding-bottom: 56.2493%;">' + "<iframe src=\"https://www.youtube.com/embed/".concat(id, "\" ") + 'style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;" ' + 'frameborder="0" allow="autoplay; encrypted-media" allowfullscreen>' + '</iframe>' + '</div>';
        }
      }, {
        name: 'vimeo',
        url: [/^vimeo\.com\/(\d+)/, /^vimeo\.com\/[^/]+\/[^/]+\/video\/(\d+)/, /^vimeo\.com\/album\/[^/]+\/video\/(\d+)/, /^vimeo\.com\/channels\/[^/]+\/(\d+)/, /^vimeo\.com\/groups\/[^/]+\/videos\/(\d+)/, /^vimeo\.com\/ondemand\/[^/]+\/(\d+)/, /^player\.vimeo\.com\/video\/(\d+)/],
        html: function html(match) {
          var id = match[1];
          return '<div style="position: relative; padding-bottom: 100%; height: 0; padding-bottom: 56.2493%;">' + "<iframe src=\"https://player.vimeo.com/video/".concat(id, "\" ") + 'style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;" ' + 'frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen>' + '</iframe>' + '</div>';
        }
      }, {
        name: 'instagram',
        url: /^instagram\.com\/p\/(\w+)/
      }, {
        name: 'twitter',
        url: /^twitter\.com/
      }, {
        name: 'googleMaps',
        url: [/^google\.com\/maps/, /^goo\.gl\/maps/, /^maps\.google\.com/, /^maps\.app\.goo\.gl/]
      }, {
        name: 'flickr',
        url: /^flickr\.com/
      }, {
        name: 'facebook',
        url: /^facebook\.com/
      }]
    });
    /**
     * The media registry managing the media providers in the editor.
     *
     * @member {module:media-embed/mediaregistry~MediaRegistry} #registry
     */

    _this.registry = new MediaRegistry(editor.locale, editor.config.get('mediaEmbed'));
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(MediaEmbedEditing, [{
    key: "init",
    value: function init() {
      var editor = this.editor;
      var schema = editor.model.schema;
      var t = editor.t;
      var conversion = editor.conversion;
      var renderMediaPreview = editor.config.get('mediaEmbed.previewsInData');
      var elementName = editor.config.get('mediaEmbed.elementName');
      var registry = this.registry;
      editor.commands.add('mediaEmbed', new MediaEmbedCommand(editor)); // Configure the schema.

      schema.register('media', {
        isObject: true,
        isBlock: true,
        allowWhere: '$block',
        allowAttributes: ['url']
      }); // Model -> Data

      conversion.for('dataDowncast').elementToElement({
        model: 'media',
        view: function view(modelElement, _ref) {
          var writer = _ref.writer;
          var url = modelElement.getAttribute('url');
          return createMediaFigureElement(writer, registry, url, {
            elementName: elementName,
            renderMediaPreview: url && renderMediaPreview
          });
        }
      }); // Model -> Data (url -> data-oembed-url)

      conversion.for('dataDowncast').add(modelToViewUrlAttributeConverter(registry, {
        elementName: elementName,
        renderMediaPreview: renderMediaPreview
      })); // Model -> View (element)

      conversion.for('editingDowncast').elementToElement({
        model: 'media',
        view: function view(modelElement, _ref2) {
          var writer = _ref2.writer;
          var url = modelElement.getAttribute('url');
          var figure = createMediaFigureElement(writer, registry, url, {
            elementName: elementName,
            renderForEditingView: true
          });
          return toMediaWidget(figure, writer, t('media widget'));
        }
      }); // Model -> View (url -> data-oembed-url)

      conversion.for('editingDowncast').add(modelToViewUrlAttributeConverter(registry, {
        elementName: elementName,
        renderForEditingView: true
      })); // View -> Model (data-oembed-url -> url)

      conversion.for('upcast') // Upcast semantic media.
      .elementToElement({
        view: function view(element) {
          return ['oembed', elementName].includes(element.name) && element.getAttribute('url') ? {
            name: true
          } : null;
        },
        model: function model(viewMedia, _ref3) {
          var writer = _ref3.writer;
          var url = viewMedia.getAttribute('url');

          if (registry.hasMedia(url)) {
            return writer.createElement('media', {
              url: url
            });
          }
        }
      }) // Upcast non-semantic media.
      .elementToElement({
        view: {
          name: 'div',
          attributes: {
            'data-oembed-url': true
          }
        },
        model: function model(viewMedia, _ref4) {
          var writer = _ref4.writer;
          var url = viewMedia.getAttribute('data-oembed-url');

          if (registry.hasMedia(url)) {
            return writer.createElement('media', {
              url: url
            });
          }
        }
      });
    }
  }], [{
    key: "pluginName",
    get:
    /**
     * @inheritDoc
     */
    function get() {
      return 'MediaEmbedEditing';
    }
  }]);

  return MediaEmbedEditing;
}(Plugin);

export { MediaEmbedEditing as default };